import dateService from '../services/util/dateService'
import loggingService from '../services/util/loggingService'

var serviceName = 'workflowService'
var path = '/Workflow/'
var isDebug = false

const WorkflowEnum = {
    FieldworkRequest: 1000,
    FileSearch: 2000,
    Investigation: 3000,
    SiteNumberRequest: 4000,
    CulturalResourceRecording: 5000,
    Isolate: 6000,
    BuildingSurvey: 7000,
    Undertaking: 8000,
    Moa: 9000,
    Pa: 10000,
    BuildingReconForm: 11000,
    E106Compliance: 12000,
    RadioCarbonReport: 13000
}

const InvestigationWorkflowStatusEnum = {
    PendingDataEntry: 3000,
    PendingAgencyAssignment: 3100,
    PendingAgencyApproval: 3200,
    Approved: 3300,
    Rejected: 3350,
    Cancelled: 3400,
    PendingUndertaking: 3450,
    PendingSHPOAssignment: 3500,
    PendingSHPOApproval: 3600,
    E106UndertakingAssigned: 3700,
    PendingQaqc: 3800
}

const FwrWorkflowStatusEnum = {
    PendingApproval: 1100,
    FwrCancelled: 1650
}

const SnrWfStatusEnum = {
    PendingDataEntry: 4000,
    PendingApproval: 4100
}

const FileSearchStatusEnum = {
    PendingDataEntry: 2000,
    Approved: 2300,
    PaymentApproved: 2400,
    PaymentApprovedTcp: 2450
}

function getWorkflowInstanceDto (http, workflowId, parentId) {
    loggingService.log(isDebug, serviceName, 'getWorkflowInstanceDto - workflowId: ' + workflowId + ', parentId: ' + parentId)
    return http.get(path + 'GetWorkflowInstanceDto?workflowId=' + workflowId + '&parentId=' + parentId).then(response => {
        if (response.data) {
            response.data.completeDateFormatted = dateService.toString(response.data.completeDate)
            response.data.completeDate = dateService.convertToDate(response.data.completeDate)
        }
        return response
    })
}

function listWorkflowStatusInstanceDto (http, workflowInstanceId) {
    loggingService.log(isDebug, serviceName, 'listWorkflowStatusInstanceDto - workflowInstanceId: ' + workflowInstanceId)

    return http.get(path + 'ListWorkflowStatusInstanceDto?workflowInstanceId=' + workflowInstanceId).then(function (response) {
        for (var i = 0; i < response.data.length; i++) {
            response.data[i].createdDate = dateService.convertToDate(response.data[i].createdDate)
            response.data[i].modifiedDate = dateService.convertToDate(response.data[i].modifiedDate)

            if (response.data[i + 1]) {
                response.data[i].duration = 'about ' + dateService.getDurationHumanized(response.data[i + 1].createdDate, response.data[i].createdDate)
            }
        }

        return response
    })
}

function listNextWorkflowStatusDto (http, workflowInstanceId) {
    loggingService.log(isDebug, serviceName, 'listNextWorkflowStatusDto - workflowInstanceId: ' + workflowInstanceId)
    return http.get(path + 'ListNextWorkflowStatusDto?workflowInstanceId=' + workflowInstanceId)
}

function submit (http, workflowInstanceId, newWorkflowStatusId, note, assignedUserId) {
    loggingService.log(isDebug, serviceName, 'submit - workflowInstanceId: ' + workflowInstanceId + ', newWorkflowStatusId: ' + newWorkflowStatusId + ', assignedUserId: ' + assignedUserId)

    var data = {
        workflowInstanceId: workflowInstanceId,
        newWorkflowStatusId: newWorkflowStatusId,
        note: note,
        assignedUserId: assignedUserId
    }

    return http.post(path + 'Submit', data)
}

function listWorkflowStatusByParent (http, workflowId, parentId) {
    return getWorkflowInstanceDto(http, workflowId, parentId).then(workflowInstanceResult => {
        var workflowInstanceId = workflowInstanceResult.data.workflowInstanceId
        loggingService.log(isDebug, serviceName, 'listWorkflowStatusByParent - workflowInstanceId: ' + workflowInstanceId)
        return listWorkflowStatusInstanceDto(http, workflowInstanceId).then(statusListResult => {
            loggingService.log(isDebug, serviceName, 'listWorkflowStatusByParent - statusList length: ' + statusListResult.data.length)
            return statusListResult
        })
    })
}

function currentWorkflowStatusDto (http, workflowId, parentId) {
    loggingService.log(isDebug, serviceName, 'currentWorkflowStatusDto - workflowId: ' + workflowId + ', parentId: ' + parentId)
    return http.get(path + 'CurrentWorkflowStatusDto?workflowId=' + workflowId + '&parentId=' + parentId)
}

function listAllWorkflowStatus (http) {
    loggingService.log(isDebug, serviceName, 'listAllWorkflowStatus')
    return http.get(path + 'ListAllWorkflowStatus')
}

function listByWorkflowId (http, workflowId) {
    loggingService.log(isDebug, serviceName, 'listByWorkflowId')
    return http.get(path + 'ListByWorkflowId?workflowId=' + workflowId)
}

function returnAllSites (http, investigationId, newStatusId) {
    loggingService.log(isDebug, serviceName, 'returnAllSites')
    return http.post(path + 'ReturnAllSites?investigationId=' + investigationId + '&workflowStatusId=' + newStatusId)
}

export default {
    WorkflowEnum: WorkflowEnum,
    InvestigationWorkflowStatusEnum: InvestigationWorkflowStatusEnum,
    FwrWorkflowStatusEnum: FwrWorkflowStatusEnum,
    SnrWfStatusEnum: SnrWfStatusEnum,
    FileSearchStatusEnum: FileSearchStatusEnum,
    getWorkflowInstanceDto: getWorkflowInstanceDto,
    listWorkflowStatusInstanceDto: listWorkflowStatusInstanceDto,
    listNextWorkflowStatusDto: listNextWorkflowStatusDto,
    listWorkflowStatusByParent: listWorkflowStatusByParent,
    currentWorkflowStatusDto: currentWorkflowStatusDto,
    submit: submit,
    listAllWorkflowStatus: listAllWorkflowStatus,
    listByWorkflowId: listByWorkflowId,
    returnAllSites: returnAllSites
}



// WEBPACK FOOTER //
// ./src/services/workflowService.js